function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 13 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.337 15.885c-.234.238-.654.082-.654-.243V9.414H.378c-.326 0-.498-.365-.281-.595L8.304.12c.23-.244.658-.09.658.239v6.201h3.66c.33 0 .5.372.277.6l-8.562 8.726zm1.232-7.541c0-.395-.338-.714-.755-.714H3.746l3.33-3.53v3.53c0 .394.338.714.755.714h1.332L5.57 12.007V8.344z",
  fill: "currentColor"
}));